import { api } from '@/core/helpers/axiosHelper';
import { Permission } from './permission.interface';

export default {
   async postBulk(body: Array<Permission>) {
      return await api.post('/permission/bulk', body).then((response) => {
         return response?.data;
      });
   },
};
